import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { TransportOrderIdView } from '../../../models';
import {
  ShipmentTransportOrderItemNotificationListCountLoad,
  ShipmentTransportOrderItemSetIdentifier,
  ShipmentTransportOrderItemSetInitial,
} from './shipment-transport-order-item.actions';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CustomHttpErrorResponse, Error } from '../../../../common/constants/error';
import { NotificationService } from '../../../../common';
import { ShipmentTransportOrderItemService } from './shipment-transport-order-item.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentTransportOrderItemStateModel {
  shipmentTransportOrderIdentifier: TransportOrderIdView;
  notificationListCount: number;
  loaded: boolean;
}

const initialState: ShipmentTransportOrderItemStateModel = {
  shipmentTransportOrderIdentifier: {
    transportOrderNumber: null,
  },
  notificationListCount: null,
  loaded: false,
};

@State<ShipmentTransportOrderItemStateModel>({
  name: 'shipmentTransportOrderItem',
  defaults: initialState,
})
@Injectable()
export class ShipmentTransportOrderItemState {
  constructor(
    private shipmentTransportOrderItemService: ShipmentTransportOrderItemService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getShipmentTransportOrderIdentifier(state: ShipmentTransportOrderItemStateModel): TransportOrderIdView {
    return state.shipmentTransportOrderIdentifier;
  }

  @Selector()
  static getLoaded(state: ShipmentTransportOrderItemStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getShipmentTransportOrderHasNotification(state: ShipmentTransportOrderItemStateModel): number {
    return state.notificationListCount;
  }

  @Action(ShipmentTransportOrderItemSetIdentifier)
  setWaybillIdentifier(
    ctx: StateContext<ShipmentTransportOrderItemStateModel>,
    { payload }: ShipmentTransportOrderItemSetIdentifier,
  ): void {
    ctx.patchState({ ...ctx.getState(), shipmentTransportOrderIdentifier: payload });
  }

  @Action(ShipmentTransportOrderItemNotificationListCountLoad)
  getShipmentTransportOrderHasNotification(
    ctx: StateContext<ShipmentTransportOrderItemStateModel>,
    { payload }: ShipmentTransportOrderItemNotificationListCountLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentTransportOrderItemService.getNotificationListCount(payload).pipe(
      map((notificationListCount: number) => {
        ctx.patchState({ ...ctx.getState(), notificationListCount, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentTransportOrderItemSetInitial)
  setInitialState(ctx: StateContext<ShipmentTransportOrderItemStateModel>): void {
    ctx.setState(initialState);
  }
}
